// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AxisScale } from '@visx/axis';
import { Line } from '@visx/shape';
import { DateTime } from 'luxon';

interface Props {
  /**
   * The y-coordinate of the segment.
   */
  y: number;

  /**
   * The height of the segment.
   */
  height: number;

  /**
   * The date scale used by the timeline containing the segment.
   */
  scale: AxisScale<number>;

  /**
   * The date of the indicator.
   */
  dateTime: DateTime;

  /**
   * The color of the segment.
   */
  color: string;
}

/**
 * An indicator that marks a specific date on the timeline with a dashed
 * vertical line.
 */
export function TimelineDateIndicator(props: Props) {
  const x = props.scale(props.dateTime.toJSDate());

  return (
    <Line
      from={{ x, y: props.y }}
      to={{ x, y: props.height }}
      strokeWidth={2}
      stroke={props.color}
      strokeDasharray="4 2"
    />
  );
}
